import React from "react";

function SubjectCard({ subject }) {
    // Get icon based on resource type
    const getIcon = (type) => {
        switch (type) {
            case "PDF": return "📄";
            case "PPT": return "📊";
            case "VIDEO": return "🎥";
            case "LINK":
                return "🔗";
            default:
                return "📁";
        }
    };
    return (
        <div className="subject-card">
            {/* Normal Subject Card */}
            <div className="subject-main">
                <div className="subject-icon">
                    {subject.icon}
                </div>
                <div className="subject-details">
                    <h3>
                        {subject.subjectName}
                    </h3>
                    <p>
                        {subject.subjectCode}
                    </p>
                </div>
                <div className="resource-count">
                    {subject.resources.length} Resources Available
                </div>
            </div>
            {/* Resources Overlay */}
            <div className="resources-overlay">
                <div className="overlay-title">
                    {subject.icon} {subject.subjectName}
                </div>
                <div className="overlay-resource-list">
                    {subject.resources.map((resource, index) => (
                        <div
                            className="overlay-resource-item"
                            key={index}
                        >
                            <div className="resource-name">
                                <span className="resource-icon">
                                    {getIcon(resource.type)}
                                </span>
                                <span>
                                    {resource.title}
                                </span>
                            </div>
                            <a
                                href={resource.viewLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="resource-view-btn"
                            > View</a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SubjectCard;